import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller } from 'react-hook-form';
import { Option, ViewSelector as Selector } from '../../../infra/ui/view-selector';
import styles from './styles.module.scss';
export var DiscountTypeSwitch = function (_a) {
    var form = _a.form, fieldName = _a.fieldName, disabled = _a.disabled, currencySymbol = _a.currencySymbol, onChange = _a.onChange;
    var handleClick = function (field, value) {
        return function () {
            field.onChange({ target: { value: value } });
            onChange(value);
        };
    };
    return (_jsx(Controller, { control: form.control, name: fieldName, render: function (_a) {
            var field = _a.field;
            return (_jsxs(Selector, { children: [_jsx(Option.Button, { type: "button", className: styles['switcher-option'], disabled: disabled, isActive: field.value === 'percentage', onClick: handleClick(field, 'percentage'), children: "%" }), _jsx(Option.Button, { type: "button", className: styles['switcher-option'], disabled: disabled, isActive: field.value === 'fixed', onClick: handleClick(field, 'fixed'), children: currencySymbol })] }));
        } }));
};
